import React from "react";

interface Props {
  label: string;
}

const ScaffoldTitle = (props: Props) => {
  return <h2 className="ScaffoldTitle">{props.label}</h2>;
};

export default React.memo(ScaffoldTitle);
